// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.dashboard h2 {
  margin-bottom: 30px;
  color: #333;
  font-size: 28px;
  font-weight: 600;
}

.no-data {
  text-align: center;
  padding: 60px 20px;
  color: #6c757d;
  font-size: 16px;
}

/* Statistics Grid */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}

.stat-card {
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.stat-icon {
  font-size: 32px;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
  border-radius: 8px;
}

.stat-content {
  flex: 1 1;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  line-height: 1;
}

.stat-label {
  font-size: 14px;
  color: #6c757d;
  margin-top: 5px;
}

/* Dashboard Sections */
.dashboard-section {
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 25px;
  margin-bottom: 30px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.dashboard-section h3 {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 20px;
  font-weight: 600;
  border-bottom: 2px solid #007bff;
  padding-bottom: 10px;
}

/* Status Breakdown */
.status-breakdown {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.status-item {
  position: relative;
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 15px;
  overflow: hidden;
}

.status-item.clickable {
  cursor: pointer;
  transition: all 0.2s ease;
}

.status-item.clickable:hover {
  background-color: #e9ecef;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.status-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  opacity: 0.1;
  transition: width 0.3s ease;
}

.status-info {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1;
}

.status-name {
  font-weight: 600;
  color: #333;
  text-transform: capitalize;
}

.status-count {
  font-size: 14px;
  color: #6c757d;
}

/* Two Column Layout */
.dashboard-columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
}

/* Top Reviewers */
.top-reviewers {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.reviewer-item {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 12px;
  background-color: #f8f9fa;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.reviewer-item.clickable {
  cursor: pointer;
}

.reviewer-item:hover,
.reviewer-item.clickable:hover {
  background-color: #e9ecef;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.reviewer-rank {
  width: 30px;
  height: 30px;
  background-color: #007bff;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 14px;
}

.reviewer-info {
  flex: 1 1;
}

.reviewer-name {
  font-weight: 600;
  color: #333;
  display: block;
}

.reviewer-count {
  font-size: 12px;
  color: #6c757d;
}

/* Recent Reviews */
.recent-reviews {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.recent-review-item {
  padding: 12px;
  background-color: #f8f9fa;
  border-radius: 6px;
  border-left: 4px solid #007bff;
  transition: all 0.2s ease;
}

.recent-review-item.clickable {
  cursor: pointer;
}

.recent-review-item.clickable:hover {
  background-color: #e9ecef;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-left-color: #0056b3;
}

.review-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.review-id {
  font-weight: 600;
  color: #333;
  font-size: 14px;
}

.review-date {
  font-size: 12px;
  color: #6c757d;
}

.review-details {
  display: flex;
  gap: 15px;
  font-size: 13px;
  color: #6c757d;
}

.review-status {
  font-weight: 600;
  text-transform: capitalize;
}

/* Responsive Design */
@media (max-width: 768px) {
  .dashboard {
    padding: 15px;
  }
  
  .dashboard h2 {
    font-size: 24px;
    margin-bottom: 20px;
  }
  
  .stats-grid {
    grid-template-columns: 1fr;
    gap: 15px;
    margin-bottom: 30px;
  }
  
  .stat-card {
    padding: 15px;
  }
  
  .stat-icon {
    font-size: 24px;
    width: 40px;
    height: 40px;
  }
  
  .stat-value {
    font-size: 20px;
  }
  
  .dashboard-columns {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .dashboard-section {
    padding: 20px;
    margin-bottom: 20px;
  }
  
  .dashboard-section h3 {
    font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,wCAAwC;EACxC,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".dashboard {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.dashboard h2 {\n  margin-bottom: 30px;\n  color: #333;\n  font-size: 28px;\n  font-weight: 600;\n}\n\n.no-data {\n  text-align: center;\n  padding: 60px 20px;\n  color: #6c757d;\n  font-size: 16px;\n}\n\n/* Statistics Grid */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n  margin-bottom: 40px;\n}\n\n.stat-card {\n  background: white;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.stat-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.stat-icon {\n  font-size: 32px;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n}\n\n.stat-content {\n  flex: 1;\n}\n\n.stat-value {\n  font-size: 24px;\n  font-weight: bold;\n  color: #333;\n  line-height: 1;\n}\n\n.stat-label {\n  font-size: 14px;\n  color: #6c757d;\n  margin-top: 5px;\n}\n\n/* Dashboard Sections */\n.dashboard-section {\n  background: white;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  padding: 25px;\n  margin-bottom: 30px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.dashboard-section h3 {\n  margin: 0 0 20px 0;\n  color: #333;\n  font-size: 20px;\n  font-weight: 600;\n  border-bottom: 2px solid #007bff;\n  padding-bottom: 10px;\n}\n\n/* Status Breakdown */\n.status-breakdown {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.status-item {\n  position: relative;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  padding: 15px;\n  overflow: hidden;\n}\n\n.status-item.clickable {\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.status-item.clickable:hover {\n  background-color: #e9ecef;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.status-bar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  opacity: 0.1;\n  transition: width 0.3s ease;\n}\n\n.status-info {\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  z-index: 1;\n}\n\n.status-name {\n  font-weight: 600;\n  color: #333;\n  text-transform: capitalize;\n}\n\n.status-count {\n  font-size: 14px;\n  color: #6c757d;\n}\n\n/* Two Column Layout */\n.dashboard-columns {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 30px;\n}\n\n/* Top Reviewers */\n.top-reviewers {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.reviewer-item {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  padding: 12px;\n  background-color: #f8f9fa;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.reviewer-item.clickable {\n  cursor: pointer;\n}\n\n.reviewer-item:hover,\n.reviewer-item.clickable:hover {\n  background-color: #e9ecef;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.reviewer-rank {\n  width: 30px;\n  height: 30px;\n  background-color: #007bff;\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.reviewer-info {\n  flex: 1;\n}\n\n.reviewer-name {\n  font-weight: 600;\n  color: #333;\n  display: block;\n}\n\n.reviewer-count {\n  font-size: 12px;\n  color: #6c757d;\n}\n\n/* Recent Reviews */\n.recent-reviews {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.recent-review-item {\n  padding: 12px;\n  background-color: #f8f9fa;\n  border-radius: 6px;\n  border-left: 4px solid #007bff;\n  transition: all 0.2s ease;\n}\n\n.recent-review-item.clickable {\n  cursor: pointer;\n}\n\n.recent-review-item.clickable:hover {\n  background-color: #e9ecef;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border-left-color: #0056b3;\n}\n\n.review-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.review-id {\n  font-weight: 600;\n  color: #333;\n  font-size: 14px;\n}\n\n.review-date {\n  font-size: 12px;\n  color: #6c757d;\n}\n\n.review-details {\n  display: flex;\n  gap: 15px;\n  font-size: 13px;\n  color: #6c757d;\n}\n\n.review-status {\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .dashboard {\n    padding: 15px;\n  }\n  \n  .dashboard h2 {\n    font-size: 24px;\n    margin-bottom: 20px;\n  }\n  \n  .stats-grid {\n    grid-template-columns: 1fr;\n    gap: 15px;\n    margin-bottom: 30px;\n  }\n  \n  .stat-card {\n    padding: 15px;\n  }\n  \n  .stat-icon {\n    font-size: 24px;\n    width: 40px;\n    height: 40px;\n  }\n  \n  .stat-value {\n    font-size: 20px;\n  }\n  \n  .dashboard-columns {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n  \n  .dashboard-section {\n    padding: 20px;\n    margin-bottom: 20px;\n  }\n  \n  .dashboard-section h3 {\n    font-size: 18px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
